module.exports = __webpack_public_path__ + "prod/20261104151832/img/map2d.f2386104.jpg";